import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function WhyPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="why-page">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-medium tracking-tight font-serif hover:text-accent transition-colors">
            Decided
          </Link>
          <Link to="/login">
            <Button variant="ghost" size="sm">
              Log in
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <h1 className="text-3xl md:text-4xl font-medium tracking-tight font-serif text-foreground">
          Why Decided
        </h1>

        <div className="mt-12 space-y-6 text-muted-foreground leading-relaxed">
          <p className="text-foreground text-lg">
            Decisions are fragile.
          </p>

          <p>
            They're made quickly, often verbally, and then forgotten.<br />
            Not because people don't care — but because there's no place for them to live.
          </p>

          <p>
            Decided is a simple place to remember:
          </p>

          <ul className="space-y-2 text-foreground">
            <li className="flex items-start gap-3">
              <span className="text-foreground/30 select-none">—</span>
              <span>what you decided</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-foreground/30 select-none">—</span>
              <span>why you decided it</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-foreground/30 select-none">—</span>
              <span>what needed to happen next</span>
            </li>
          </ul>

          <p>
            It's not a project manager.<br />
            It's not a task list.
          </p>

          <p>
            Decided is built for people who make decisions every day and want them to stick.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link>
            <Link to="/why" className="hover:text-foreground transition-colors">Why Decided</Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
            <Link to="/login" className="hover:text-foreground transition-colors">Login</Link>
          </div>
          <p className="mt-6 text-center text-xs text-muted-foreground/50">
            © {new Date().getFullYear()} Decided
          </p>
        </div>
      </footer>
    </div>
  );
}
